import { useMutation } from "@apollo/client";
import { MARK_NOTIFICATION_AS_READ } from "../notification.queries";
import {
  MarkNotificationAsReadMutation,
  MarkNotificationAsReadMutationVariables,
} from "../../../__generated__/MarkNotificationAsReadMutation";

export const useMarkNotificationAsRead = () => {
  return useMutation<
    MarkNotificationAsReadMutation,
    MarkNotificationAsReadMutationVariables
  >(MARK_NOTIFICATION_AS_READ, {
    refetchQueries: "active",
  });
};
